export default __webpack_public_path__ + "0949b5f5fe909066eed30a7ba4e06def.png";